import { render } from "./Paginate.vue?vue&type=template&id=c45ce84e&scoped=true"
const script = {}

import "./Paginate.vue?vue&type=style&index=0&id=c45ce84e&scoped=true&lang=css"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45ce84e"]])

export default __exports__